export default function Toggle({ on, onChange }) {
  return (
    <div onClick={() => onChange(!on)} style={{ width:32, height:18, borderRadius:9, background: on ? "var(--ink)" : "var(--border)", position:"relative", cursor:"pointer", transition:"background 0.15s", flexShrink:0 }}>
      <div style={{ position:"absolute", top:2, left: on ? 14 : 2, width:14, height:14, borderRadius:"50%", background:"#fff", boxShadow:"0 1px 3px rgba(0,0,0,0.2)", transition:"left 0.15s" }} />
    </div>
  );
}
